// The pages behind the + menu (sections/offer-info.liquid): the menu, the tick table's info
// buttons, and the one-collection carousel.
(function () {
  const $ = id => document.getElementById(id);
  const menu = $('menu'), btn = $('menuBtn');
  function setMenu(on) {
    document.body.classList.toggle('menu-open', on); menu.classList.toggle('on', on);
    menu.setAttribute('aria-hidden', String(!on)); btn.setAttribute('aria-expanded', String(on));
  }
  btn.addEventListener('click', () => setMenu(!menu.classList.contains('on')));
  menu.addEventListener('click', e => { if (e.target.closest('[aria-current]')) setMenu(false); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') setMenu(false); });

  // The limited release: no bag yet, so the cart says when it opens.
  const soon = $('cartSoon');
  if (soon) soon.addEventListener('click', () => {
    let t = document.querySelector('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = soon.dataset.soon; t.classList.add('on');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('on'), 3200);
  });

  // ---------- Reserve the first hour ----------
  const rf = $('reserveForm');
  if (rf) {
    const KEY = 'deeds-first-hour';
    const q = new URLSearchParams(location.search);
    if (q.get('email')) $('rEmail').value = q.get('email');          // the emails can link with ?email=
    const showDone = () => {
      rf.hidden = true; $('reserveDone').hidden = false;
    };
    try { const r = JSON.parse(localStorage.getItem(KEY) || 'null'); if (r) showDone(); } catch (e) {}
    const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    // Where Klaviyo goes in (not connected yet): subscribe the profile (first and last name, email,
    // phone, country, property first_hour_reserved) to the first-hour list with email consent, and
    // SMS consent when ticked, through Klaviyo's client subscriptions API with the public site key.
    // Klaviyo's public client API (the site key is public by design, the list is the
    // "Reserved day one" list). Email consent is what the person ticks by reserving.
    // The mobile number is kept as a property with the SMS tick; no SMS subscription is
    // made here, because text sending is not set up and Klaviyo would refuse the call.
    // 2026-10-24: tracking blockers (uBlock, AdGuard, Brave, Firefox strict) refuse
    // browser calls to klaviyo.com, which showed "could not reserve" to those
    // visitors. The reservation now goes first-party to our bridge, which records
    // it and hands it to Klaviyo. Only if the bridge itself is unreachable does the
    // page fall back to calling Klaviyo directly. A 400 from either means the
    // address itself was refused, and the message says so.
    const BRIDGE = 'https://api.deeds.store/api/waitlist';
    async function submitReservation(data) {
      if (rf.dataset.connected !== 'true') { await new Promise(r => setTimeout(r, 500)); return true; }
      try {
        const res = await fetch(BRIDGE, { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ op: 'reserve', email: data.email, first_name: data.first_name, last_name: data.last_name, phone: data.phone, country: data.country }) });
        if (res.ok) return true;
        if (res.status === 400) throw new Error('invalid');
        throw new Error('bridge ' + res.status);
      } catch (e) {
        if (e && e.message === 'invalid') throw e;
      }
      return submitToKlaviyo(data);
    }
    async function submitToKlaviyo(data) {
      const key = rf.dataset.klaviyoKey, list = rf.dataset.klaviyoList;
      if (!key || !list) throw new Error('Klaviyo key or list missing');
      const properties = { reserved_day_one: true, reserved_at: new Date().toISOString(), reserve_country: data.country };
      if (data.phone) properties.mobile = data.phone;
      const body = { data: { type: 'subscription', attributes: {
        custom_source: 'Reserve your spot on day one',
        profile: { data: { type: 'profile', attributes: {
          email: data.email, first_name: data.first_name || undefined, last_name: data.last_name || undefined,
          location: data.country === 'Other' ? undefined : { country: data.country }, properties,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: list } } } } };
      const res = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(key), {
        method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2025-07-15' }, body: JSON.stringify(body) });
      if (res.status === 400) throw new Error('invalid');
      if (res.status !== 202 && !res.ok) throw new Error('Klaviyo answered ' + res.status);
      return true;
    }
    rf.addEventListener('submit', async e => {
      e.preventDefault();
      const err = $('reserveError'); err.textContent = '';
      rf.querySelectorAll('.bad').forEach(x => x.classList.remove('bad'));
      const email = $('rEmail').value.trim().toLowerCase(), phone = $('rPhone').value.trim();
      const bad = [];
      if (!$('rFirst').value.trim()) bad.push([$('rFirst'), 'Please add your first name.']);
      if (!EMAIL_RX.test(email)) bad.push([$('rEmail'), 'That email address does not look complete, please check it.']);
      if (!$('rCountry').value) bad.push([$('rCountry'), 'Please choose your country.']);
      if (phone && !/^\+?[\d\s()-]{7,}$/.test(phone)) bad.push([$('rPhone'), 'Please add your mobile number with its country code, or leave it blank.']);
      if (bad.length) { bad.forEach(([el]) => el.classList.add('bad')); err.textContent = bad[0][1]; bad[0][0].focus(); return; }
      if ($('rWebsite').value) { showDone(); return; }
      const btn = $('reserveBtn'), label = btn.textContent; btn.textContent = 'Reserving'; btn.classList.add('busy');
      try {
        await submitReservation({ first_name: $('rFirst').value.trim(), last_name: $('rLast').value.trim(), email, phone, country: $('rCountry').value });
        try { localStorage.setItem(KEY, JSON.stringify({ done: true })); } catch (e2) {}
        showDone();
      } catch (e2) {
        err.textContent = e2 && e2.message === 'invalid'
          ? 'That email address was not accepted. Please check it and try again.'
          : 'We could not reserve your spot just now. Please try again, or email hello@deeds.store and we will add you.';
      }
      btn.textContent = label; btn.classList.remove('busy');
    });
  }

  document.querySelectorAll('.cmp .info').forEach(b => b.addEventListener('click', () => {
    const row = $(b.getAttribute('aria-controls')), open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', String(open)); row.hidden = !open;
  }));

  // One collection, a bead at a time: arrows, dots, the keyboard's arrows and a swipe move it;
  // the light switch lights every bead (a hover lights the one showing, CSS).
  const coll = $('coll');
  if (coll) {
    const slides = [...coll.querySelectorAll('.slide')], dots = [...$('collDots').children];
    let at = 0;
    const go = i => {
      at = (i + slides.length) % slides.length;
      slides.forEach((s, k) => { s.classList.toggle('on', k === at); s.setAttribute('aria-hidden', String(k !== at)); });
      dots.forEach((d, k) => (k === at ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')));
      [at + 1, at - 1].forEach(k => slides[(k + slides.length) % slides.length].querySelectorAll('img').forEach(im => { im.loading = 'eager'; }));
    };
    $('collPrev').addEventListener('click', () => go(at - 1));
    $('collNext').addEventListener('click', () => go(at + 1));
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    document.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') go(at - 1); if (e.key === 'ArrowRight') go(at + 1); });
    let x0 = null;
    $('collTrack').addEventListener('pointerdown', e => { x0 = e.clientX; });
    $('collTrack').addEventListener('pointerup', e => { if (x0 !== null && Math.abs(e.clientX - x0) > 40) go(at + (e.clientX < x0 ? 1 : -1)); x0 = null; });
    $('collLight').addEventListener('click', () => {
      const on = !coll.classList.contains('is-lit');
      coll.classList.toggle('is-lit', on); $('collLight').setAttribute('aria-pressed', String(on));
    });
  }
})();
